module.exports = __webpack_public_path__ + "img/career roadmaps.bc4b9ae6.png";